"use client"
import React from 'react'
import Styling from '@/library/styling'
import { useSearchParams } from 'next/navigation'
import MainWrapper from '@/library/blocks/sections/MainWrapper'
import SearchAll from '@/library/entities/search/SearchAll'

// ... (SearchComponent remains the same)

export default function SearchPage() {
  const searchParams = useSearchParams()
  const initialQuery = searchParams.get('query') || ''

  return (
    <MainWrapper>
      <div className="container mx-auto px-4 py-8 min-h-screen mt-20">
        <h1 className={`${Styling.sizes.heading1.default} mb-8`}>Search</h1>
        <SearchAll initialQuery={initialQuery} />
      </div>
    </MainWrapper>
  )
}
